import { type FC } from "react";

import { css } from "@emotion/css";
import { Spinner } from "@snapchat/snap-design-system";

import { useLensInfoCards } from "../../../hooks";
import { StatsEmptyState } from "../../shared";

import { TopLensCard } from "./LensCard";
import { TopLensesContainer } from "./TopLensesSection.styles";

const centredContent = css`
    justify-content: center;
`;

export const LensCards: FC = () => {
    const { isLoading, isEmpty, topLensesCards } = useLensInfoCards();

    if (isLoading) {
        return (
            <TopLensesContainer className={centredContent}>
                <Spinner />
            </TopLensesContainer>
        );
    }

    if (isEmpty) {
        return (
            <TopLensesContainer>
                <StatsEmptyState
                    title="Not enough Data"
                    description="Top Lenses will be available when your Lens(es) get enough popularity"
                />
            </TopLensesContainer>
        );
    }

    return (
        <TopLensesContainer>
            {topLensesCards.map((lens) => (
                <TopLensCard key={lens.id} lens={lens} />
            ))}
        </TopLensesContainer>
    );
};
